import { atom, useAtom } from 'jotai';
import type { TemplateChannel } from './channels';

// Set on mount from the languages the company actually writes in: a tenant without French
// must not open the editor on a body that does not exist.
const templateLanguageAtom = atom<string | null>(null);

export const useTemplateLanguageAtom = () => {
  return useAtom(templateLanguageAtom);
};

const activeChannelAtom = atom<TemplateChannel | null>(null);

export const useActiveChannelAtom = () => {
  return useAtom(activeChannelAtom);
};

// Edited body content per template/channel/locale, serialized to {{variable}} form,
// so switching tabs or languages (which remounts the editor) does not lose edits.
type TemplateDrafts = Record<string, string>;

const templateDraftsAtom = atom<TemplateDrafts>({});

export const useTemplateDraftsAtom = () => {
  return useAtom(templateDraftsAtom);
};

// Edited sending options (email only) per template/channel/locale, so edits survive
// language switches and are picked up by the manual save alongside body drafts.
export type SendingOptionsDraft = {
  subject: string;
  fromName: string;
  fromEmail: string;
  replyToName: string;
  replyToEmail: string;
};

type SendingOptionsDrafts = Record<string, Partial<SendingOptionsDraft>>;

const sendingOptionsDraftsAtom = atom<SendingOptionsDrafts>({});

export const useSendingOptionsDraftsAtom = () => {
  return useAtom(sendingOptionsDraftsAtom);
};

export const draftKey = (templateId: string, channel: string, locale: string) =>
  `${templateId}:${channel}:${locale}`;
